import $ from 'jquery';
import './jquery.ips.searchhint.scss';

$(document).ready(function() {
    $(".sidebar-sticky").stick_in_parent({
        parent: ".content-wrapper",
        spacer: false,
    });

    let initialSidebarHeight = 0;
    if($('.sidebar').length>0) {
        // initialSidebarHeight = $('.sidebar').height();
        initialSidebarHeight = $.makeArray($('.sidebar__block')).reduce((l,r)=> l+$(r).height(),0)
    }
    let initialContentHeight = 0;
    if ($('.content').length > 0) {
        initialContentHeight = $('.content').height();
    }
    // console.log("initialSidebarHeight: ",initialSidebarHeight);
    if($("#flexibleFrame").length>0) {
        $(window).on('message', function (e) {
            var data = e.originalEvent.data;
            var frameElement=$("#flexibleFrame");
            if (/^__ips_frame_height/.test(data)) {
                var docHeight = parseInt(data.substring("__ips_frame_height".length));
                var frameHeight = parseInt(frameElement.height());
                if(docHeight!==frameHeight) {
                    // console.log("doc height: ",docHeight);
                    // correcting content
                    let minContentHeight=initialSidebarHeight + parseInt(docHeight);
                    // console.log('Min Content Height is ',minContentHeight);

                    if($('.content').length>0) {
                        // console.log("Correcting content .... ");
                        $('.content').css('min-height',minContentHeight+'px');
                        // console.log("Setup min size to: ", minContentHeight);
                    }

                    // console.log("Correcting column .... ",docHeight,frameHeight);
                    $("#flexibleFrame").height(docHeight);

                    // recalculate sticky lib
                    if($('.sidebar-sticky').length>0) {
                        $('.sidebar-sticky').trigger('sticky_kit:recalc');
                        // console.log("Recalculating ....");
                    }

                }
            }
        });
    }

    $("#search-bar").hint({
        debug: true,
        searchHintCloseButtonSelector: '.search__btn-close'
    });
});


//////////////////
// WEBPACK FOOTER
// ./src/common.js
// module id = 354
// module chunks = 4